/**
 * Mobility Insights Utilities
 *
 * Risk level configurations and helper functions
 * for the Mobility Insights Results screen.
 */

// Risk level configurations
export const RISK_LEVELS = {
  high: {
    key: "high",
    label: "High Risk of Fall",
    status: "poor",
  },
  elevated: {
    key: "elevated",
    label: "Elevated Fall Risk",
    status: "fair",
  },
  low: {
    key: "low",
    label: "Low Fall Risk",
    status: "good",
  },
  processing: {
    key: "processing",
    label: "Processing...",
    status: "default",
  },
};

/**
 * Get risk level configuration
 */
export const getRiskLevelConfig = (riskLevel, isProcessing = false) => {
  if (isProcessing && !riskLevel) {
    return RISK_LEVELS.processing;
  }
  return RISK_LEVELS[riskLevel] || RISK_LEVELS.low;
};

/**
 * Format assessment date
 */
export const formatAssessmentDate = (dateString) => {
  if (!dateString) return "";
  const date = new Date(dateString);
  return date.toLocaleDateString("en-US", {
    month: "long",
    day: "numeric",
    year: "numeric",
  });
};
